import { Component, Prop, Vue } from 'vue-property-decorator';

import { Switch as cSwitch } from '@coreui/vue';

@Component({
    name: 'CreateGroupRow',
    components: {
        cSwitch
    }
})
export default class CreateGroupRow extends Vue {
    @Prop(String) private entityName!: string;
    @Prop(Array) private roles!: any;
    @Prop(Object) private role!: any;

    private get show() {
        return this.role.SHOW;
    }
    private get list() {
        return this.role.LIST;
    }
    private get create() {
        return this.role.CREATE;
    }
    private get edit() {
        return this.role.EDIT;
    }
    private get remove() {
        return this.role.DELETE;
    }
    private get custom() {
        return this.role.CUSTOM;
    }
    
    private isChecked (role:any) {
        return Boolean(this.roles.find((el:any) => el === role));
    }

    private handleRoleChange (event:any) {
        const { value, name, checked } = event.target;
        
        this.$emit('onRoleChanged', {
            value,
            name,
            checked
        });
    }
}
